module.exports = __webpack_public_path__ + "components/rewards/dragon-lodge/static/logo-35d1ab54ec00949aefe7449c3a0f9aa3.webp";